// 라벨 한 개를 설명하는 문구를 고르는 단일 규칙.
//
// 서버 `description` 이 SoT 다. Labels 화면에서 관리자가 직접 편집하는 값이고, 시드 카탈로그도
// 모든 managed 라벨에 이 값을 가진다. FE 가이드(`labelGuide`)는 폴백이다. 서버 행이 없는
// 자리(리뷰 초안 칩, vocab 으로만 만드는 facet)와 description 이 빈 라벨에만 쓴다.
//
// 이 규칙을 한 함수로 고정하는 이유: 표면마다 우선순위가 다르면 같은 라벨이 화면마다 다른 문장을
// 표시한다. 예: Labels 목록에서 칩 툴팁이 가이드를 쓰고 바로 옆 설명 컬럼이 서버 값을 쓰면, 한
// 행 안에서 두 문장이 다르다.
//
// 최종 폴백(칩 텍스트, `key:value`, 표시 안 함)은 표면마다 다르다. 그래서 여기서 고르지 않고 null 을 반환한다.

import { labelGuideSummary } from "./labelGuide";

export type ExplainableLabel = {
  key: string;
  value: string;
  // 서버 라벨 행의 설명. 행이 없는 호출부(초안 칩 등)는 값을 주지 않는다.
  description?: string | null;
};

export function labelExplanation(label: ExplainableLabel): string | null {
  // 공백만 남은 description 도 빈 값으로 본다. 관리자가 설명을 지우면 `""` 로 저장될 수 있다.
  // `??` 만 쓰면 빈 툴팁이 표시된다.
  const described = label.description?.trim();
  if (described !== undefined && described !== "") {
    return described;
  }
  return labelGuideSummary(label.key, label.value);
}
